import { render, staticRenderFns } from "./B104.vue?vue&type=template&id=e5909abe&scoped=true"
import script from "./B104.vue?vue&type=script&lang=js"
export * from "./B104.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=e5909abe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5909abe",
  null
  
)

export default component.exports